import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import styled from '@emotion/styled'
import ContentsWrapper from 'src/components/atoms/wrappers/ContentsWrapper'
import HeadingBorder from 'src/components/atoms/HeadingBorder'
import HeadTitle from 'src/components/atoms/HeadTitle'
import { BreakPoint, Styles } from 'src/components/shared/CssValues'
import { NoLineBreak } from 'src/components/atoms/NoLineBreak'
import { PointCard } from 'src/components/molecules/PointCard'
import { PointCardLayout } from 'src/components/molecules/PointCardLayout'
import { Typography } from 'src/components/atoms/Typography'

const points = [
  {
    imageName: 'communication',
    title: 'コミュニ\nケーション\nの\n集約',
    description:
      '必要な情報にユーザーが迷わず辿り着けるように。回遊も発生しコンテンツ価値が最大化。'
  },
  {
    imageName: 'interactive',
    title: '双方向化',
    description:
      'ユーザー間でのコミュニケーションによる自発的な課題解決を促進。インサイトの発掘も容易に。'
  },
  {
    imageName: 'data',
    title: 'データ分析に\n基づく\nアクションの\n最適化',
    description:
      'データが一つのプラットフォームに集約されることで、精度の高い分析と個別最適なアクションが可能に。'
  }
]

const TopAbout = ({top}) => {
  const data = useStaticQuery(graphql`
    query {
      communication: file(relativePath: { eq: "top/communication.svg" }) {
        publicURL
      }
      interactive: file(relativePath: { eq: "top/interactive.svg" }) {
        publicURL
      }
      data: file(relativePath: { eq: "top/data.svg" }) {
        publicURL
      }
      customerSuccess: file(relativePath: { eq: "top/customer-success.svg" }) {
        publicURL
      }
    }
  `)

  return (
    <Container>
      <ContentsWrapper>
        <HeadingBorder heading="ABOUT" />
        <HeadTitle as="h2">
          <NoLineBreak>commmuneが</NoLineBreak>
            <NoLineBreak>{top ? "提供する価値" : "選ばれる理由"}</NoLineBreak>
        </HeadTitle>
        <PointCardGridLayoutWrapper>
          <PointCardLayout skip2column>
            {points.map(point => {
              const { publicURL } = data[point.imageName]
              return (
                <PointCard
                  key={point.imageName}
                  {...point}
                  imageUrl={publicURL}
                />
              )
            })}
          </PointCardLayout>
        </PointCardGridLayoutWrapper>
        {top &&
          <FeaturedPointWrapper>
            <FeaturedPointMessage>
              <HeadTitle as="h3">
                <NoLineBreak>カスタマー</NoLineBreak>
                <NoLineBreak>サクセスの</NoLineBreak>
                <NoLineBreak>強力な支援</NoLineBreak>
              </HeadTitle>
              <FeaturedPointDescription>
                <NoLineBreak>実績に裏打ちされた</NoLineBreak>
                <NoLineBreak>カスタマーサクセスが</NoLineBreak>
                <NoLineBreak>運用を支援。</NoLineBreak>
              </FeaturedPointDescription>
              <FeaturedPointDescription>
                <NoLineBreak>コミュニティ施策の</NoLineBreak>
                <NoLineBreak>成功率を</NoLineBreak>
                <NoLineBreak>最大化するために、</NoLineBreak>
                <NoLineBreak>パートナーとして</NoLineBreak>
                <NoLineBreak>戦略検討から</NoLineBreak>
                <NoLineBreak>運用サポートまで</NoLineBreak>
                <NoLineBreak>伴走します。</NoLineBreak>
              </FeaturedPointDescription>
            </FeaturedPointMessage>
            <FeaturedPointImageWrapper>
              <FeaturedPointImage src={data.customerSuccess.publicURL} alt="" />
            </FeaturedPointImageWrapper>
          </FeaturedPointWrapper>
        }
      </ContentsWrapper>
    </Container>
  )
}

const Container = styled.section`
  padding: ${Styles.spacing[11]} 0;
  @media screen and (min-width: ${BreakPoint.MOBILE}) {
    padding: ${Styles.spacing[10]} 0;
  }
`
const PointCardGridLayoutWrapper = styled.div`
  margin: ${Styles.spacing[11]} 0 0;
  @media screen and (min-width: ${BreakPoint.TABLET}) {
    margin: 0;
  }
`

const FeaturedPointWrapper = styled.div`
  background: ${Styles.color.primary[200]};
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  margin: ${Styles.spacing[12]} 0 0;
  padding: ${Styles.spacing[9]} ${Styles.spacing[9]} ${Styles.spacing[11]};
  border-radius: ${Styles.borderRadius[4]};
  @media screen and (min-width: ${BreakPoint.TABLET}) {
    flex-direction: row;
    padding: ${Styles.spacing[11]} ${Styles.spacing[12]};
  }
  @media screen and (min-width: ${BreakPoint.LAPTOP_L}) {
    box-sizing: border-box;
    padding: ${Styles.spacing[11]} ${Styles.spacing[12]};
    margin: ${Styles.spacing[12]} calc(${Styles.spacing[12]} * -1) 0;
  }
`

const FeaturedPointMessage = styled.div`
  flex: 1;
  min-width: 0;
  text-align: center;
  margin: ${Styles.spacing[10]} 0 0;
  max-width: 420px;
  @media screen and (min-width: ${BreakPoint.TABLET}) {
    text-align: left;
    margin: 0 ${Styles.spacing[10]} 0 0;
    max-width: 100%;
  }
`

const FeaturedPointDescription = styled(Typography)`
  margin: ${Styles.spacing[7]} 0 0;
  font-size: ${Styles.fontSize[300]};
  line-height: ${Styles.lineHeight[400]};
  @media screen and (min-width: ${BreakPoint.TABLET}) {
    font-size: ${Styles.fontSize[400]};
  }
`
const FeaturedPointImageWrapper = styled.div`
  padding: ${Styles.spacing[4]} ${Styles.spacing[4]} 0;
  @media screen and (min-width: ${BreakPoint.MOBILE}) {
    padding: ${Styles.spacing[8]} 0 0;
    max-width: 70%;
  }
  @media screen and (min-width: ${BreakPoint.TABLET}) {
    padding: 0;
    max-width: 50%;
  }
`

const FeaturedPointImage = styled.img`
  max-width: 100%;
  height: auto;
`

export default TopAbout
